"use strict";
var ddSdk_1 = require("./lib/ddSdk");
var otherApi = require("./lib/otherApi");
var core = Object.assign({}, otherApi, ddSdk_1.ddSdk.getExportSdk());
module.exports = core;
